import React, { useEffect, useState } from "react"

const pad = (n) => String(Math.max(0, n)).padStart(2, "0")

const split = (ms) => {
  const total = Math.max(0, Math.floor(ms / 1000))
  return {
    days: Math.floor(total / 86400),
    hours: Math.floor((total % 86400) / 3600),
    minutes: Math.floor((total % 3600) / 60),
    seconds: total % 60
  }
}

/** Countdown to `target` (a Date); `label` sits above the digits. */
const BfCountdown = ({ target, label = "începe în", compact = false, className = "" }) => {
  const [now, setNow] = useState(() => Date.now())

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000)
    return () => clearInterval(id)
  }, [])

  const t = split(target.getTime() - now)
  const cells = [
    [t.days, "zile"],
    [t.hours, "ore"],
    [t.minutes, "min"],
    [t.seconds, "sec"]
  ]

  return (
    <div className={`bf-countdown ${compact ? "compact" : ""} ${className}`}>
      {label && <div className="bf-countdown__label">{label}</div>}
      <div className="bf-countdown__cells">
        {cells.map(([value, unit], i) => (
          <React.Fragment key={unit}>
            {i > 0 && <span className="bf-countdown__sep">:</span>}
            <div className="bf-countdown__cell">
              <span className="bf-countdown__value">{pad(value)}</span>
              <span className="bf-countdown__unit">{unit}</span>
            </div>
          </React.Fragment>
        ))}
      </div>
    </div>
  )
}

export default BfCountdown
